export default {
  columns: {
    version: 'Version',
    signed_at: 'Unterzeichnet am',
    internal_note: 'Interne Notiz',
    signature_provider: 'Signaturanbieter',
    file: 'Dokument',
    actions: 'Aktionen',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Noch kein Unterschriftsverlauf vorhanden',
    providers: {
      selfhosted: 'Selbst gehostet',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Vorschau',
    download: 'Herunterladen',
  },
};
